import { isAndroidNative, isIOSNative } from './platform';
import { sendMessage } from './index';
// import { AndroidMethodName, IOSMethodName, PLATFORM } from './config';
/**
 * 支持手雷的统一 toast
 * @param message toast 内容
 */
export function toast(message = '未知错误，请稍后再试') {
    if (isAndroidNative) {
        sendMessage({
            platform: 'android',
            name: 'xlShowToast',
            params: { message },
        }, { noCallback: true });
    }
    else if (isIOSNative) {
        sendMessage({
            platform: 'ios',
            name: 'toastMessage',
            params: { message },
        }, { noCallback: true });
    }
    else {
        // TODO
    }
}
/**
 * 支持手雷的统一上报
 * @param ct hubbleEventId or eventId
 * @param action hubbleAttribute1 or subEventId
 * @param extData 扩展 key value 对象值
 */
export function stat(ct, action, extData) {
    isAndroidNative &&
        sendMessage({
            platform: 'android',
            name: 'xlReportStatistics',
            params: {
                hubbleEventId: ct,
                hubbleAttribute1: action,
                hubbleExData: extData,
            },
        }, { noCallback: true });
    isIOSNative &&
        sendMessage({
            platform: 'ios',
            name: 'trackEvent',
            params: {
                eventId: ct,
                subEventId: action,
                extData,
            },
        }, { noCallback: true });
}
/**
 * 支持手雷的统一关闭页面
 */
export function close() {
    isAndroidNative &&
        sendMessage({ platform: 'android', name: 'xlFinishSelfActivity' }, { noCallback: true });
    isIOSNative &&
        sendMessage({ platform: 'ios', name: 'xlCloseView' }, { noCallback: true });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0aG9kcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvbWV0aG9kcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLFdBQVcsRUFBRSxNQUFNLFlBQVksQ0FBQztBQUMxRCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBQ3RDLHlFQUF5RTtBQUV6RTs7O0dBR0c7QUFDRixNQUFNLFVBQVUsS0FBSyxDQUFDLFVBQWtCLFlBQVk7SUFDbkQsSUFBSSxlQUFlLEVBQUU7UUFDbkIsV0FBVyxDQUNUO1lBQ0UsUUFBUSxFQUFFLFNBQVM7WUFDbkIsSUFBSSxFQUFFLGFBQWE7WUFDbkIsTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFO1NBQ3BCLEVBQ0QsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQ3JCLENBQUM7S0FDSDtTQUFNLElBQUksV0FBVyxFQUFFO1FBQ3RCLFdBQVcsQ0FDVDtZQUNFLFFBQVEsRUFBRSxLQUFLO1lBQ2YsSUFBSSxFQUFFLGNBQWM7WUFDcEIsTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFO1NBQ3BCLEVBQ0QsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQ3JCLENBQUM7S0FDSDtTQUFNO1FBQ0wsT0FBTztLQUNSO0FBQ0gsQ0FBQztBQUVEOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLElBQUksQ0FBQyxFQUFVLEVBQUUsTUFBYyxFQUFFLE9BQWU7SUFDOUQsZUFBZTtRQUNiLFdBQVcsQ0FDVDtZQUNFLFFBQVEsRUFBRSxTQUFTO1lBQ25CLElBQUksRUFBRSxvQkFBb0I7WUFDMUIsTUFBTSxFQUFFO2dCQUNOLGFBQWEsRUFBRSxFQUFFO2dCQUNqQixnQkFBZ0IsRUFBRSxNQUFNO2dCQUN4QixZQUFZLEVBQUUsT0FBTzthQUN0QjtTQUNGLEVBQ0QsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQ3JCLENBQUM7SUFDSixXQUFXO1FBQ1QsV0FBVyxDQUNUO1lBQ0UsUUFBUSxFQUFFLEtBQUs7WUFDZixJQUFJLEVBQUUsWUFBWTtZQUNsQixNQUFNLEVBQUU7Z0JBQ04sT0FBTyxFQUFFLEVBQUU7Z0JBQ1gsVUFBVSxFQUFFLE1BQU07Z0JBQ2xCLE9BQU87YUFDUjtTQUNGLEVBQ0QsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQ3JCLENBQUM7QUFDTixDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsS0FBSztJQUNuQixlQUFlO1FBQ2IsV0FBVyxDQUNULEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsc0JBQXNCLEVBQUUsRUFDckQsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQ3JCLENBQUM7SUFDSixXQUFXO1FBQ1QsV0FBVyxDQUNULEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsYUFBYSxFQUFFLEVBQ3hDLEVBQUUsVUFBVSxFQUFFLElBQUksRUFBRSxDQUNyQixDQUFDO0FBQ04sQ0FBQyJ9